import { useState, useCallback } from 'react';
import {updateUserByUsername} from "../../services/Sysadmin/getUsers";

const useUpdateUser = () => {
    const [loading, setLoading] = useState(false);

    const updateUser = useCallback(async (username:string, toBeUpdated:any) => {
        setLoading(true);
        try {
            const response:any = await updateUserByUsername(username, toBeUpdated)
            return response.data;
        } catch (err) {
            throw err;
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    }, []);

    return { updateUser, loading };
};

export default useUpdateUser;
